export const kpis = [
  { label: "Open Claims", value: "1,284", delta: "-12.4%", trend: "down", hint: "vs last month" },
  {
    label: "Avg Resolution Time",
    value: "6.2 days",
    delta: "-1.8d",
    trend: "down",
    hint: "8D cycle time",
  },
  {
    label: "Warranty Cost (MTD)",
    value: "$2.41M",
    delta: "-18.7%",
    trend: "down",
    hint: "Predicted savings",
  },
  {
    label: "Predicted Defects (30d)",
    value: "342",
    delta: "+4.1%",
    trend: "up",
    hint: "AI forecast",
  },
];

export const claimsTrend = [
  { month: "Jan", claims: 1820, resolved: 1640, predicted: 1900 },
  { month: "Feb", claims: 1710, resolved: 1580, predicted: 1750 },
  { month: "Mar", claims: 1890, resolved: 1720, predicted: 1820 },
  { month: "Apr", claims: 1640, resolved: 1610, predicted: 1680 },
  { month: "May", claims: 1520, resolved: 1490, predicted: 1560 },
  { month: "Jun", claims: 1410, resolved: 1380, predicted: 1450 },
  { month: "Jul", claims: 1284, resolved: 1240, predicted: 1320 },
];

export const warrantyCostForecast: {
  month: string;
  actual: number | null;
  forecast: number;
  upper: number;
  lower: number;
  budget: number;
}[] = [
  { month: "Nov '25", actual: 3.12, forecast: 3.05, upper: 3.3, lower: 2.8, budget: 3.2 },
  { month: "Dec '25", actual: 3.04, forecast: 3.1, upper: 3.34, lower: 2.86, budget: 3.2 },
  { month: "Jan '26", actual: 2.88, forecast: 2.95, upper: 3.18, lower: 2.72, budget: 3.1 },
  { month: "Feb '26", actual: 2.71, forecast: 2.8, upper: 3.02, lower: 2.58, budget: 3.1 },
  { month: "Mar '26", actual: 2.6, forecast: 2.65, upper: 2.84, lower: 2.46, budget: 3.0 },
  { month: "Apr '26", actual: 2.49, forecast: 2.52, upper: 2.7, lower: 2.34, budget: 3.0 },
  { month: "May '26", actual: 2.41, forecast: 2.44, upper: 2.6, lower: 2.28, budget: 2.95 },
  { month: "Jun '26", actual: null, forecast: 2.32, upper: 2.52, lower: 2.12, budget: 2.95 },
  { month: "Jul '26", actual: null, forecast: 2.21, upper: 2.46, lower: 1.96, budget: 2.9 },
  { month: "Aug '26", actual: null, forecast: 2.1, upper: 2.4, lower: 1.8, budget: 2.9 },
  { month: "Sep '26", actual: null, forecast: 2.02, upper: 2.36, lower: 1.68, budget: 2.85 },
  { month: "Oct '26", actual: null, forecast: 1.94, upper: 2.32, lower: 1.56, budget: 2.85 },
];

// Per-product-line warranty cost ($M) — actuals + AI forecast for sparkline cards.
// Each series shares the same 12-month axis as warrantyCostForecast.
export const warrantyCostByLine: {
  key: string;
  label: string;
  series: { month: string; actual: number | null; forecast: number }[];
}[] = [
  {
    key: "evx",
    label: "EV-X Platform",
    series: [
      { month: "Nov '25", actual: 1.18, forecast: 1.15 },
      { month: "Dec '25", actual: 1.14, forecast: 1.16 },
      { month: "Jan '26", actual: 1.08, forecast: 1.1 },
      { month: "Feb '26", actual: 1.01, forecast: 1.04 },
      { month: "Mar '26", actual: 0.96, forecast: 0.98 },
      { month: "Apr '26", actual: 0.92, forecast: 0.93 },
      { month: "May '26", actual: 0.88, forecast: 0.9 },
      { month: "Jun '26", actual: null, forecast: 0.85 },
      { month: "Jul '26", actual: null, forecast: 0.81 },
      { month: "Aug '26", actual: null, forecast: 0.77 },
      { month: "Sep '26", actual: null, forecast: 0.74 },
      { month: "Oct '26", actual: null, forecast: 0.71 },
    ],
  },
  {
    key: "hybrid",
    label: "Hybrid Series",
    series: [
      { month: "Nov '25", actual: 0.86, forecast: 0.84 },
      { month: "Dec '25", actual: 0.82, forecast: 0.85 },
      { month: "Jan '26", actual: 0.78, forecast: 0.8 },
      { month: "Feb '26", actual: 0.74, forecast: 0.76 },
      { month: "Mar '26", actual: 0.7, forecast: 0.72 },
      { month: "Apr '26", actual: 0.67, forecast: 0.68 },
      { month: "May '26", actual: 0.65, forecast: 0.66 },
      { month: "Jun '26", actual: null, forecast: 0.63 },
      { month: "Jul '26", actual: null, forecast: 0.6 },
      { month: "Aug '26", actual: null, forecast: 0.57 },
      { month: "Sep '26", actual: null, forecast: 0.55 },
      { month: "Oct '26", actual: null, forecast: 0.53 },
    ],
  },
  {
    key: "ice",
    label: "ICE Legacy",
    series: [
      { month: "Nov '25", actual: 0.74, forecast: 0.72 },
      { month: "Dec '25", actual: 0.72, forecast: 0.74 },
      { month: "Jan '26", actual: 0.68, forecast: 0.7 },
      { month: "Feb '26", actual: 0.64, forecast: 0.66 },
      { month: "Mar '26", actual: 0.61, forecast: 0.62 },
      { month: "Apr '26", actual: 0.58, forecast: 0.59 },
      { month: "May '26", actual: 0.56, forecast: 0.57 },
      { month: "Jun '26", actual: null, forecast: 0.54 },
      { month: "Jul '26", actual: null, forecast: 0.51 },
      { month: "Aug '26", actual: null, forecast: 0.48 },
      { month: "Sep '26", actual: null, forecast: 0.46 },
      { month: "Oct '26", actual: null, forecast: 0.44 },
    ],
  },
  {
    key: "fleet",
    label: "Fleet & Commercial",
    series: [
      { month: "Nov '25", actual: 0.34, forecast: 0.34 },
      { month: "Dec '25", actual: 0.36, forecast: 0.35 },
      { month: "Jan '26", actual: 0.34, forecast: 0.35 },
      { month: "Feb '26", actual: 0.32, forecast: 0.34 },
      { month: "Mar '26", actual: 0.33, forecast: 0.33 },
      { month: "Apr '26", actual: 0.32, forecast: 0.32 },
      { month: "May '26", actual: 0.32, forecast: 0.31 },
      { month: "Jun '26", actual: null, forecast: 0.3 },
      { month: "Jul '26", actual: null, forecast: 0.29 },
      { month: "Aug '26", actual: null, forecast: 0.28 },
      { month: "Sep '26", actual: null, forecast: 0.27 },
      { month: "Oct '26", actual: null, forecast: 0.26 },
    ],
  },
];

// Claims per 1,000 vehicles in service (C/1000) by Months In Service (MIS)
// Industry benchmark target: < 12 C/1000 at MIS 12; warning > 18.
export const claimsPerThousand: {
  mis: number;
  evx: number;
  hybrid: number;
  ice: number;
  fleet: number | null;
  target: number;
  warning: number;
}[] = [
  { mis: 1, evx: 1.2, hybrid: 0.9, ice: 0.7, fleet: 1.0, target: 2, warning: 4 },
  { mis: 2, evx: 2.4, hybrid: 1.7, ice: 1.4, fleet: 2.1, target: 3, warning: 6 },
  { mis: 3, evx: 4.1, hybrid: 2.8, ice: 2.3, fleet: 3.4, target: 5, warning: 8 },
  { mis: 4, evx: 5.8, hybrid: 3.9, ice: 3.2, fleet: 4.8, target: 6, warning: 10 },
  { mis: 5, evx: 7.4, hybrid: 5.0, ice: 4.0, fleet: 6.1, target: 8, warning: 12 },
  { mis: 6, evx: 9.1, hybrid: 6.2, ice: 4.9, fleet: 7.6, target: 9, warning: 14 },
  { mis: 7, evx: 10.8, hybrid: 7.3, ice: 5.7, fleet: 9.0, target: 10, warning: 15 },
  { mis: 8, evx: 12.4, hybrid: 8.4, ice: 6.5, fleet: 10.4, target: 11, warning: 16 },
  { mis: 9, evx: 13.9, hybrid: 9.4, ice: 7.2, fleet: 11.7, target: 11, warning: 17 },
  { mis: 10, evx: 15.2, hybrid: 10.3, ice: 7.9, fleet: null, target: 12, warning: 18 },
  { mis: 11, evx: 16.4, hybrid: 11.1, ice: 8.5, fleet: null, target: 12, warning: 18 },
  { mis: 12, evx: 17.5, hybrid: 11.8, ice: 9.0, fleet: null, target: 12, warning: 18 },
];

// SPC control chart — monthly claim counts by component (last 12 months)
// Used to compute control limits (CL, UCL, LCL) at ±3σ using a moving-range approach.
export type ControlChartComponent = {
  key: string;
  label: string;
  unit: string;
  spec: string;
  series: { month: string; claims: number }[];
};

export const claimsControlChart: ControlChartComponent[] = [
  {
    key: "hv-battery",
    label: "HV Battery Pack",
    unit: "claims/month",
    spec: "Spec: 8D-2451 — cell-balance drift",
    series: [
      { month: "Jun '25", claims: 41 },
      { month: "Jul '25", claims: 47 },
      { month: "Aug '25", claims: 52 },
      { month: "Sep '25", claims: 49 },
      { month: "Oct '25", claims: 58 },
      { month: "Nov '25", claims: 64 },
      { month: "Dec '25", claims: 71 },
      { month: "Jan '26", claims: 88 },
      { month: "Feb '26", claims: 92 },
      { month: "Mar '26", claims: 76 },
      { month: "Apr '26", claims: 69 },
      { month: "May '26", claims: 61 },
    ],
  },
  {
    key: "inverter",
    label: "Inverter / Power Electronics",
    unit: "claims/month",
    spec: "Spec: PFMEA-INV-014 — IGBT thermal",
    series: [
      { month: "Jun '25", claims: 22 },
      { month: "Jul '25", claims: 25 },
      { month: "Aug '25", claims: 28 },
      { month: "Sep '25", claims: 24 },
      { month: "Oct '25", claims: 31 },
      { month: "Nov '25", claims: 34 },
      { month: "Dec '25", claims: 39 },
      { month: "Jan '26", claims: 44 },
      { month: "Feb '26", claims: 41 },
      { month: "Mar '26", claims: 36 },
      { month: "Apr '26", claims: 33 },
      { month: "May '26", claims: 29 },
    ],
  },
  {
    key: "infotainment",
    label: "Infotainment Head-Unit",
    unit: "claims/month",
    spec: "Spec: SW-OTA-9.4 — boot-loop regression",
    series: [
      { month: "Jun '25", claims: 58 },
      { month: "Jul '25", claims: 61 },
      { month: "Aug '25", claims: 55 },
      { month: "Sep '25", claims: 63 },
      { month: "Oct '25", claims: 59 },
      { month: "Nov '25", claims: 67 },
      { month: "Dec '25", claims: 72 },
      { month: "Jan '26", claims: 65 },
      { month: "Feb '26", claims: 60 },
      { month: "Mar '26", claims: 57 },
      { month: "Apr '26", claims: 54 },
      { month: "May '26", claims: 52 },
    ],
  },
  {
    key: "brake-system",
    label: "Brake System / ABS",
    unit: "claims/month",
    spec: "Spec: PFMEA-BRK-007 — caliper seal",
    series: [
      { month: "Jun '25", claims: 18 },
      { month: "Jul '25", claims: 16 },
      { month: "Aug '25", claims: 19 },
      { month: "Sep '25", claims: 17 },
      { month: "Oct '25", claims: 21 },
      { month: "Nov '25", claims: 20 },
      { month: "Dec '25", claims: 18 },
      { month: "Jan '26", claims: 22 },
      { month: "Feb '26", claims: 19 },
      { month: "Mar '26", claims: 17 },
      { month: "Apr '26", claims: 18 },
      { month: "May '26", claims: 16 },
    ],
  },
  {
    key: "door-module",
    label: "Door Control Module",
    unit: "claims/month",
    spec: "Spec: 8D-2398 — latch sensor noise",
    series: [
      { month: "Jun '25", claims: 33 },
      { month: "Jul '25", claims: 31 },
      { month: "Aug '25", claims: 29 },
      { month: "Sep '25", claims: 34 },
      { month: "Oct '25", claims: 32 },
      { month: "Nov '25", claims: 30 },
      { month: "Dec '25", claims: 28 },
      { month: "Jan '26", claims: 31 },
      { month: "Feb '26", claims: 33 },
      { month: "Mar '26", claims: 30 },
      { month: "Apr '26", claims: 29 },
      { month: "May '26", claims: 27 },
    ],
  },
];

export const failureModes = [
  { name: "Electrical", value: 38, color: "var(--color-primary)" },
  { name: "Mechanical", value: 27, color: "var(--color-accent)" },
  { name: "Software", value: 18, color: "var(--color-warning)" },
  { name: "Cosmetic", value: 11, color: "var(--color-success)" },
  { name: "Other", value: 6, color: "var(--color-muted-foreground)" },
];

export const eightDStages = [
  { code: "D1", label: "Team", count: 42 },
  { code: "D2", label: "Problem", count: 38 },
  { code: "D3", label: "Containment", count: 51 },
  { code: "D4", label: "Root Cause", count: 67 },
  { code: "D5", label: "Corrective", count: 34 },
  { code: "D6", label: "Implement", count: 29 },
  { code: "D7", label: "Prevent", count: 22 },
  { code: "D8", label: "Closure", count: 18 },
];

export type EightDStatus = "On Track" | "At Risk" | "Overdue";

export const activeCases: {
  id: string;
  product: string;
  issue: string;
  stage: string;
  owner: string;
  age: number;
  severity: "Critical" | "High" | "Medium" | "Low";
  status: EightDStatus;
}[] = [
  {
    id: "8D-2041",
    product: "PowerCell X7",
    issue: "Battery thermal shutdown",
    stage: "D4 — Root Cause",
    owner: "M. Chen",
    age: 4,
    severity: "Critical",
    status: "On Track",
  },
  {
    id: "8D-2039",
    product: "AeroPump V3",
    issue: "Seal failure at 800h",
    stage: "D6 — Implement",
    owner: "A. Kowalski",
    age: 11,
    severity: "High",
    status: "At Risk",
  },
  {
    id: "8D-2036",
    product: "ControlNode K2",
    issue: "Firmware boot loop",
    stage: "D3 — Containment",
    owner: "R. Patel",
    age: 2,
    severity: "High",
    status: "On Track",
  },
  {
    id: "8D-2031",
    product: "DriveUnit DU-9",
    issue: "Bearing wear premature",
    stage: "D5 — Corrective",
    owner: "S. Müller",
    age: 14,
    severity: "Medium",
    status: "Overdue",
  },
  {
    id: "8D-2028",
    product: "PowerCell X7",
    issue: "Connector oxidation",
    stage: "D7 — Prevent",
    owner: "L. García",
    age: 9,
    severity: "Medium",
    status: "On Track",
  },
  {
    id: "8D-2024",
    product: "SensorPack S5",
    issue: "Drift beyond spec",
    stage: "D2 — Problem",
    owner: "T. Yamada",
    age: 1,
    severity: "Low",
    status: "On Track",
  },
];

export const teamMembers = [
  "M. Chen",
  "A. Kowalski",
  "R. Patel",
  "S. Müller",
  "L. García",
  "T. Yamada",
  "P. Andersson",
  "K. Okafor",
];

// Day offsets from "today" used to seed milestone due dates per case (D1..D8).
// Negative values are in the past, so completed milestones look on-time
// and incomplete ones with negative offsets surface as overdue.
export const milestoneDueOffsets: Record<string, number[]> = {
  "8D-2041": [-6, -4, -2, 1, 4, 8, 12, 18],
  "8D-2039": [-14, -11, -8, -5, -2, 3, 9, 15],
  "8D-2036": [-3, -1, 2, 5, 9, 14, 20, 28],
  "8D-2031": [-18, -15, -12, -9, -5, -1, 4, 10],
  "8D-2028": [-12, -9, -6, -3, 0, 4, 9, 16],
  "8D-2024": [-2, 1, 4, 7, 11, 16, 22, 30],
};

// PFMEA + Control Plan rows tied to 8D cases.
// D4 (Root Cause) feeds the PFMEA cause/effect + S/O/D scoring.
// D5 (Corrective) drives the Control Plan method that lowers RPN.
export type PfmeaControlRow = {
  caseId: string;
  product: string;
  process: string;
  failureMode: string;
  effect: string;
  cause: string; // from D4
  sevBefore: number;
  occBefore: number;
  detBefore: number;
  corrective: string; // from D5
  control: string;
  frequency: string;
  reaction: string;
  owner: string;
  sevAfter: number;
  occAfter: number;
  detAfter: number;
};

export const pfmeaControl: PfmeaControlRow[] = [
  {
    caseId: "8D-2041",
    product: "PowerCell X7",
    process: "Cell formation & aging",
    failureMode: "Thermal runaway shutdown",
    effect: "Field unit disable, safety event risk",
    cause: "Cell batch #B-2204 separator porosity drift",
    sevBefore: 9,
    occBefore: 6,
    detBefore: 5,
    corrective: "Tighten separator spec + supplier SPC gate",
    control: "100% in-line impedance + IR scan",
    frequency: "Every cell, each shift",
    reaction: "Quarantine batch, notify SQE",
    owner: "M. Chen",
    sevAfter: 9,
    occAfter: 2,
    detAfter: 2,
  },
  {
    caseId: "8D-2039",
    product: "AeroPump V3",
    process: "Seal press-fit",
    failureMode: "Dynamic seal leak @ 800h",
    effect: "Pump pressure loss, warranty return",
    cause: "Supplier elastomer hardness shift (Shore +6)",
    sevBefore: 8,
    occBefore: 7,
    detBefore: 6,
    corrective: "Lock supplier lot + incoming hardness test",
    control: "AQL hardness sample + torque audit",
    frequency: "Each incoming lot",
    reaction: "Reject lot, switch to qualified backup",
    owner: "A. Kowalski",
    sevAfter: 8,
    occAfter: 3,
    detAfter: 3,
  },
  {
    caseId: "8D-2036",
    product: "ControlNode K2",
    process: "Firmware flash & boot test",
    failureMode: "Boot loop on cold start",
    effect: "DOA on customer install",
    cause: "FW 4.2 watchdog race in init sequence",
    sevBefore: 7,
    occBefore: 8,
    detBefore: 4,
    corrective: "Patch 4.2.1 + extended cold-soak EOL test",
    control: "Automated cold-boot cycle at EOL",
    frequency: "100% units",
    reaction: "Re-flash, fail unit to MRB",
    owner: "R. Patel",
    sevAfter: 7,
    occAfter: 2,
    detAfter: 2,
  },
  {
    caseId: "8D-2031",
    product: "DriveUnit DU-9",
    process: "Bearing assembly",
    failureMode: "Premature bearing wear",
    effect: "Vibration, premature replacement",
    cause: "Bearing lot variance — out-of-round race",
    sevBefore: 7,
    occBefore: 6,
    detBefore: 7,
    corrective: "Add roundness gauge + supplier CpK requirement",
    control: "Roundness check + vibration EOL",
    frequency: "Sample n=5/lot + 100% EOL",
    reaction: "Hold lot, root-cause with supplier",
    owner: "S. Müller",
    sevAfter: 7,
    occAfter: 3,
    detAfter: 2,
  },
];

// Read-Across: applying lessons learned from a closed/active 8D to other
// products, lines, or programs that share the same component, process, or
// supplier. Status reflects whether the receiving program has acted on the
// lesson yet. Risk avoided is the predicted RPN reduction × exposed units.
export type ReadAcrossStatus = "Applied" | "In Review" | "Open" | "Not Applicable";

export type ReadAcrossRow = {
  sourceCaseId: string;
  lesson: string;
  rootCauseTag: string; // common denominator (component / process / supplier)
  targets: {
    product: string;
    program: string;
    owner: string;
    status: ReadAcrossStatus;
    actionDue: string; // ISO date
    riskAvoided: string; // $ or units narrative
  }[];
};

export const readAcross: ReadAcrossRow[] = [
  {
    sourceCaseId: "8D-2041",
    lesson:
      "Tighten separator porosity spec + 100% in-line impedance scan on all Li-ion cell lines using batch #B-22xx series.",
    rootCauseTag: "Cell separator · Supplier batch B-22xx",
    targets: [
      {
        product: "PowerCell X5",
        program: "Legacy fleet",
        owner: "M. Chen",
        status: "Applied",
        actionDue: "2026-04-22",
        riskAvoided: "$340K · 2,100 units",
      },
      {
        product: "PowerCell M2",
        program: "Mobility OEM",
        owner: "L. García",
        status: "In Review",
        actionDue: "2026-05-28",
        riskAvoided: "$210K · 1,400 units",
      },
      {
        product: "GridStore G1",
        program: "Stationary storage",
        owner: "K. Okafor",
        status: "Open",
        actionDue: "2026-06-10",
        riskAvoided: "$180K · 900 units",
      },
    ],
  },
  {
    sourceCaseId: "8D-2039",
    lesson:
      "Lock elastomer supplier lot and add incoming Shore-A hardness AQL to every dynamic-seal assembly.",
    rootCauseTag: "Elastomer seal · Supplier hardness drift",
    targets: [
      {
        product: "AeroPump V2",
        program: "Service spares",
        owner: "A. Kowalski",
        status: "Applied",
        actionDue: "2026-04-30",
        riskAvoided: "$120K · 540 units",
      },
      {
        product: "HydroValve H4",
        program: "Industrial line",
        owner: "P. Andersson",
        status: "In Review",
        actionDue: "2026-05-20",
        riskAvoided: "$95K · 380 units",
      },
    ],
  },
  {
    sourceCaseId: "8D-2036",
    lesson:
      "Add automated cold-soak boot cycle to EOL test for any product running shared bootloader 4.x.",
    rootCauseTag: "Firmware 4.x · Watchdog init race",
    targets: [
      {
        product: "ControlNode K1",
        program: "Field-installed base",
        owner: "R. Patel",
        status: "Applied",
        actionDue: "2026-04-18",
        riskAvoided: "$220K · 3,400 units",
      },
      {
        product: "EdgeGate E2",
        program: "Telemetry gateway",
        owner: "T. Yamada",
        status: "In Review",
        actionDue: "2026-05-15",
        riskAvoided: "$140K · 1,800 units",
      },
      {
        product: "SensorPack S5",
        program: "Next-gen rollout",
        owner: "T. Yamada",
        status: "Open",
        actionDue: "2026-06-02",
        riskAvoided: "$80K · 950 units",
      },
    ],
  },
  {
    sourceCaseId: "8D-2031",
    lesson:
      "Require supplier CpK ≥ 1.67 on bearing roundness and add vibration EOL across all rotating drive families.",
    rootCauseTag: "Bearing supplier · Roundness CpK",
    targets: [
      {
        product: "DriveUnit DU-7",
        program: "Mature platform",
        owner: "S. Müller",
        status: "Applied",
        actionDue: "2026-04-12",
        riskAvoided: "$160K · 720 units",
      },
      {
        product: "DriveUnit DU-11",
        program: "NPI ramp",
        owner: "S. Müller",
        status: "In Review",
        actionDue: "2026-05-25",
        riskAvoided: "$110K · 480 units",
      },
      {
        product: "AeroPump V3",
        program: "Cross-family",
        owner: "A. Kowalski",
        status: "Not Applicable",
        actionDue: "2026-04-30",
        riskAvoided: "Different bearing source",
      },
    ],
  },
];

export const predictiveAlerts = [
  {
    product: "PowerCell X7",
    risk: 87,
    window: "30 days",
    units: "1,240 units",
    driver: "Cell batch #B-2204 anomaly",
  },
  {
    product: "AeroPump V3",
    risk: 72,
    window: "45 days",
    units: "860 units",
    driver: "Seal supplier shift",
  },
  {
    product: "ControlNode K2",
    risk: 58,
    window: "60 days",
    units: "2,110 units",
    driver: "Firmware 4.2 regression",
  },
  {
    product: "DriveUnit DU-9",
    risk: 41,
    window: "90 days",
    units: "540 units",
    driver: "Bearing lot variance",
  },
];

// Audit trail entries — every governance-relevant action mapped to the
// applicable IATF 16949 (auto sector, supersedes TS 16949) and ISO 9001:2015
// clauses, so the dashboard doubles as evidence for surveillance audits.
export type AuditStandard = "IATF 16949" | "ISO 9001" | "Both";

export type AuditEntry = {
  id: string;
  timestamp: string; // ISO datetime
  actor: string;
  action: string;
  detail: string;
  caseId?: string;
  evidence: string; // record / artifact reference
  standards: { name: "IATF 16949" | "ISO 9001"; clause: string; title: string }[];
};

export const auditTrail: AuditEntry[] = [
  {
    id: "AUD-10241",
    timestamp: "2026-05-13T08:42:00Z",
    actor: "M. Chen",
    action: "Opened 8D",
    detail:
      "8D-2041 PowerCell X7 thermal shutdown — D1 team chartered, D2 problem statement signed.",
    caseId: "8D-2041",
    evidence: "8D record · Team charter v1",
    standards: [
      { name: "IATF 16949", clause: "10.2.3", title: "Problem solving (8D)" },
      { name: "ISO 9001", clause: "10.2.1", title: "Nonconformity & corrective action" },
    ],
  },
  {
    id: "AUD-10242",
    timestamp: "2026-05-13T10:15:00Z",
    actor: "Quality system",
    action: "Containment verified",
    detail:
      "8D-2036 ControlNode K2 — D3 quarantine of 2,110 suspect units confirmed at DC + plant.",
    caseId: "8D-2036",
    evidence: "Quarantine log Q-3318",
    standards: [
      { name: "IATF 16949", clause: "8.7.1.4", title: "Control of reworked product" },
      { name: "ISO 9001", clause: "8.7", title: "Control of nonconforming outputs" },
    ],
  },
  {
    id: "AUD-10243",
    timestamp: "2026-05-12T16:08:00Z",
    actor: "A. Kowalski",
    action: "PFMEA updated",
    detail: "AeroPump V3 dynamic seal — occurrence rating 7→3 after supplier hardness gate.",
    caseId: "8D-2039",
    evidence: "PFMEA rev 7 · Sign-off SQE+ENG",
    standards: [
      { name: "IATF 16949", clause: "8.3.5.2", title: "Manufacturing process design — PFMEA" },
      { name: "ISO 9001", clause: "8.3.3", title: "Design & development inputs" },
    ],
  },
  {
    id: "AUD-10244",
    timestamp: "2026-05-12T11:30:00Z",
    actor: "R. Patel",
    action: "Control Plan revised",
    detail: "ControlNode K2 — added automated cold-soak boot cycle to EOL test station.",
    caseId: "8D-2036",
    evidence: "Control Plan CP-K2 rev 4",
    standards: [
      { name: "IATF 16949", clause: "8.5.1.1", title: "Control plan" },
      { name: "ISO 9001", clause: "8.5.1", title: "Control of production" },
    ],
  },
  {
    id: "AUD-10245",
    timestamp: "2026-05-11T14:55:00Z",
    actor: "S. Müller",
    action: "Corrective action verified",
    detail: "8D-2031 DriveUnit DU-9 — D5 effectiveness check passed on 3 consecutive lots.",
    caseId: "8D-2031",
    evidence: "Effectiveness study EF-2031",
    standards: [
      { name: "IATF 16949", clause: "10.2.5", title: "Warranty management systems" },
      { name: "ISO 9001", clause: "10.2.2", title: "Records of nonconformity" },
    ],
  },
  {
    id: "AUD-10246",
    timestamp: "2026-05-11T09:20:00Z",
    actor: "L. García",
    action: "Read-across applied",
    detail: "Lesson from 8D-2041 propagated to PowerCell X5 legacy fleet — Control Plan updated.",
    caseId: "8D-2041",
    evidence: "RA log RA-X5-014",
    standards: [
      { name: "IATF 16949", clause: "7.1.6", title: "Organizational knowledge — lessons learned" },
      { name: "ISO 9001", clause: "10.3", title: "Continual improvement" },
    ],
  },
  {
    id: "AUD-10247",
    timestamp: "2026-05-10T17:02:00Z",
    actor: "K. Okafor",
    action: "Customer notification",
    detail: "8D interim report issued to customer for AeroPump V3 seal containment.",
    caseId: "8D-2039",
    evidence: "Customer comm CN-2039-INT",
    standards: [
      {
        name: "IATF 16949",
        clause: "10.2.6",
        title: "Customer complaints & field failure test analysis",
      },
      { name: "ISO 9001", clause: "8.2.1", title: "Customer communication" },
    ],
  },
  {
    id: "AUD-10248",
    timestamp: "2026-05-10T08:00:00Z",
    actor: "Internal audit",
    action: "Layered process audit",
    detail: "LPA on EOL boot test cell — 0 findings, evidence captured for Q2 surveillance.",
    evidence: "LPA report LPA-2026-Q2-07",
    standards: [
      { name: "IATF 16949", clause: "9.2.2.3", title: "Manufacturing process audit" },
      { name: "ISO 9001", clause: "9.2", title: "Internal audit" },
    ],
  },
  {
    id: "AUD-10249",
    timestamp: "2026-05-09T13:45:00Z",
    actor: "T. Yamada",
    action: "Document control",
    detail: "Work instruction WI-S5-12 revised B→C and released; obsolete copies withdrawn.",
    evidence: "DCN-S5-0427",
    standards: [
      { name: "IATF 16949", clause: "7.5.3.2.1", title: "Record retention" },
      { name: "ISO 9001", clause: "7.5", title: "Documented information" },
    ],
  },
  {
    id: "AUD-10250",
    timestamp: "2026-05-08T15:25:00Z",
    actor: "P. Andersson",
    action: "Management review input",
    detail: "Warranty cost trend & 8D KPIs submitted to monthly QMR pack.",
    evidence: "QMR-2026-05 Annex C",
    standards: [
      { name: "IATF 16949", clause: "9.3.2.1", title: "Management review inputs — supplemental" },
      { name: "ISO 9001", clause: "9.3", title: "Management review" },
    ],
  },
];

// ============================================================================
// Recall & Safety — ties warranty signals (8D, PFMEA, SPC breaches, predictive
// risk) to safety activities: TREAD/NHTSA reporting readiness, field actions,
// safety campaigns, and recall decision workflow.
// ============================================================================

export type SafetySeverity = "S1-Catastrophic" | "S2-Critical" | "S3-Major" | "S4-Minor";
export type FieldActionType = "Recall" | "Service Campaign" | "TSB" | "Customer Advisory";
export type FieldActionStatus =
  | "Monitoring"
  | "Investigation"
  | "Decision Pending"
  | "Filed with NHTSA"
  | "In Execution"
  | "Closed";

export type FieldAction = {
  id: string;
  title: string;
  linkedCaseId?: string;
  linkedComponentKey?: string;
  product: string;
  type: FieldActionType;
  status: FieldActionStatus;
  severity: SafetySeverity;
  populationVins: number;
  completionPct: number; // % of population remedied
  openedOn: string; // ISO
  regulatoryDueDays: number; // days remaining to 5-day TREAD window (negative = overdue)
  driver: string;
};

export const fieldActions: FieldAction[] = [
  {
    id: "FA-2026-004",
    title: "HV battery pack — thermal runaway risk on batch B-2204",
    linkedCaseId: "8D-2041",
    linkedComponentKey: "hv-battery",
    product: "EV-X Platform",
    type: "Recall",
    status: "Filed with NHTSA",
    severity: "S1-Catastrophic",
    populationVins: 12480,
    completionPct: 38,
    openedOn: "2026-04-18",
    regulatoryDueDays: 0,
    driver: "SPC breach + 3 field fire reports · 8D-2041 D4 root cause",
  },
  {
    id: "FA-2026-003",
    title: "ABS caliper seal — brake drag under sustained load",
    linkedComponentKey: "brake-system",
    product: "Hybrid Series",
    type: "Service Campaign",
    status: "In Execution",
    severity: "S2-Critical",
    populationVins: 4820,
    completionPct: 71,
    openedOn: "2026-03-02",
    regulatoryDueDays: 0,
    driver: "PFMEA-BRK-007 · Sev 8 / Occ 4 post-corrective",
  },
  {
    id: "FA-2026-002",
    title: "Inverter IGBT thermal derate — power loss event",
    linkedComponentKey: "inverter",
    product: "EV-X Platform",
    type: "Recall",
    status: "Decision Pending",
    severity: "S2-Critical",
    populationVins: 2110,
    completionPct: 0,
    openedOn: "2026-05-04",
    regulatoryDueDays: 2,
    driver: "PFMEA-INV-014 · 44 claims in Jan '26 exceeded UCL",
  },
  {
    id: "FA-2026-001",
    title: "Infotainment boot-loop — OTA remedy 4.2.1",
    linkedCaseId: "8D-2036",
    linkedComponentKey: "infotainment",
    product: "Hybrid Series",
    type: "TSB",
    status: "In Execution",
    severity: "S4-Minor",
    populationVins: 18300,
    completionPct: 84,
    openedOn: "2026-02-14",
    regulatoryDueDays: 0,
    driver: "SW-OTA-9.4 regression · non-safety, informational bulletin",
  },
  {
    id: "FA-2026-005",
    title: "Door latch sensor noise — false ajar warning",
    linkedComponentKey: "door-module",
    product: "ICE Legacy",
    type: "Customer Advisory",
    status: "Monitoring",
    severity: "S4-Minor",
    populationVins: 6400,
    completionPct: 0,
    openedOn: "2026-05-06",
    regulatoryDueDays: 0,
    driver: "8D-2398 · below SPC threshold, watch item",
  },
];

// Safety signals — leading indicators that escalate warranty items into
// potential field actions. Each signal maps to a source: field incident
// reports, VOC/social, dealer diagnostic uploads, or SPC breaches.
export type SafetySignal = {
  id: string;
  source: "Field Incident" | "SPC Breach" | "Dealer Diagnostic" | "VOC / Social" | "Predictive AI";
  componentKey: string;
  component: string;
  description: string;
  severity: SafetySeverity;
  count: number;
  trend: "up" | "flat" | "down";
  loggedOn: string; // ISO
  linkedActionId?: string;
};

export const safetySignals: SafetySignal[] = [
  {
    id: "SS-4411",
    source: "Field Incident",
    componentKey: "hv-battery",
    component: "HV Battery Pack",
    description: "Thermal event — vehicle fire, no injury",
    severity: "S1-Catastrophic",
    count: 3,
    trend: "up",
    loggedOn: "2026-05-11",
    linkedActionId: "FA-2026-004",
  },
  {
    id: "SS-4408",
    source: "SPC Breach",
    componentKey: "inverter",
    component: "Inverter / Power Electronics",
    description: "Jan '26 claims above +3σ UCL",
    severity: "S2-Critical",
    count: 44,
    trend: "up",
    loggedOn: "2026-02-03",
    linkedActionId: "FA-2026-002",
  },
  {
    id: "SS-4405",
    source: "Dealer Diagnostic",
    componentKey: "brake-system",
    component: "Brake System / ABS",
    description: "DTC C0045 cluster on sustained-grade routes",
    severity: "S2-Critical",
    count: 62,
    trend: "flat",
    loggedOn: "2026-03-01",
    linkedActionId: "FA-2026-003",
  },
  {
    id: "SS-4402",
    source: "Predictive AI",
    componentKey: "hv-battery",
    component: "HV Battery Pack",
    description: "Model flags 1,240 units at 87% risk in 30d",
    severity: "S2-Critical",
    count: 1240,
    trend: "up",
    loggedOn: "2026-05-08",
    linkedActionId: "FA-2026-004",
  },
  {
    id: "SS-4399",
    source: "VOC / Social",
    componentKey: "infotainment",
    component: "Infotainment Head-Unit",
    description: "Owner forum posts re: boot loop rising",
    severity: "S4-Minor",
    count: 187,
    trend: "down",
    loggedOn: "2026-04-22",
    linkedActionId: "FA-2026-001",
  },
  {
    id: "SS-4396",
    source: "Dealer Diagnostic",
    componentKey: "door-module",
    component: "Door Control Module",
    description: "False B1015 ajar warning across model years",
    severity: "S4-Minor",
    count: 41,
    trend: "flat",
    loggedOn: "2026-04-30",
    linkedActionId: "FA-2026-005",
  },
];

// Recall decision matrix — scores warranty items against safety severity to
// support the go/no-go on field action escalation.
export type RecallDecisionRow = {
  componentKey: string;
  component: string;
  severity: SafetySeverity;
  claimVelocity: "Rising" | "Stable" | "Falling";
  spcState: "In Control" | "Warning" | "Breach";
  injuriesReported: number;
  regulatoryTrigger: boolean;
  recommendation: "Recall" | "Service Campaign" | "TSB" | "Monitor";
  linkedActionId?: string;
};

export const recallDecisionMatrix: RecallDecisionRow[] = [
  {
    componentKey: "hv-battery",
    component: "HV Battery Pack",
    severity: "S1-Catastrophic",
    claimVelocity: "Rising",
    spcState: "Breach",
    injuriesReported: 0,
    regulatoryTrigger: true,
    recommendation: "Recall",
    linkedActionId: "FA-2026-004",
  },
  {
    componentKey: "inverter",
    component: "Inverter / Power Electronics",
    severity: "S2-Critical",
    claimVelocity: "Rising",
    spcState: "Breach",
    injuriesReported: 0,
    regulatoryTrigger: true,
    recommendation: "Recall",
    linkedActionId: "FA-2026-002",
  },
  {
    componentKey: "brake-system",
    component: "Brake System / ABS",
    severity: "S2-Critical",
    claimVelocity: "Stable",
    spcState: "Warning",
    injuriesReported: 0,
    regulatoryTrigger: false,
    recommendation: "Service Campaign",
    linkedActionId: "FA-2026-003",
  },
  {
    componentKey: "infotainment",
    component: "Infotainment Head-Unit",
    severity: "S4-Minor",
    claimVelocity: "Falling",
    spcState: "In Control",
    injuriesReported: 0,
    regulatoryTrigger: false,
    recommendation: "TSB",
    linkedActionId: "FA-2026-001",
  },
  {
    componentKey: "door-module",
    component: "Door Control Module",
    severity: "S4-Minor",
    claimVelocity: "Falling",
    spcState: "In Control",
    injuriesReported: 0,
    regulatoryTrigger: false,
    recommendation: "Monitor",
    linkedActionId: "FA-2026-005",
  },
];
